import React from 'react'
import { Form, Checkbox } from 'components/forms'
import { ContentBlock } from 'components/ContentBlock'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import updateProperties from '../../fragments/mutateProductProperties'
import { useMutation } from '../../../../components/graphql'
import { updateProductProperties } from '../../gql/mutation'

const SelfCheckout = ({ data, formData }) => {
	const [t] = useTranslation()
	const [mutate] = useMutation(updateProductProperties)

	return (
		<ContentBlock>
			<Form initialValues={formData}
				onSubmit={({ properties }) => updateProperties({ productId: data.id, ...properties }, mutate)}
				smartSubmit
			>
				<Row>
					<Col xs>
						<Checkbox field='properties.SCOFoodTray' label={t('product_section.fields.food_tray')} />
						<Checkbox field='properties.SCOKitchenComponent' label={t('product_section.fields.kitchen_component')} />
					</Col>
				</Row>
			</Form>
		</ContentBlock>
	)
}

export default SelfCheckout
